import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import FileReceiver from "./FileReceiver";
import TelegramLocalPreview from "./TelegramLocalPreview";

const MESSAGE_META = {
  error: {
    icon: ErrorOutlineIcon,
    label: "Ошибка",
  },
  info: {
    icon: CheckCircleOutlineIcon,
    label: "Готово",
  },
  help: {
    icon: InfoOutlinedIcon,
    label: "Подсказка",
  },
};

function StartPostPreview({ preview, label = "Пример для клиента" }) {
  if (!preview) return null;

  return (
    <article className="tg-start-post">
      {label ? <div className="tg-start-post__label">{label}</div> : null}
      {preview.posterSrc ? (
        <div
          className={`tg-start-post__media${
            preview.posterSrc.includes("inchat-logo")
              ? " tg-start-post__media--logo"
              : ""
          }`}
        >
          <img src={preview.posterSrc} alt="" />
        </div>
      ) : null}
      <div className="tg-start-post__caption">
        {preview.title ? (
          <p className="tg-start-post__title">{preview.title}</p>
        ) : null}
        {preview.description ? <p>{preview.description}</p> : null}
      </div>
      {preview.isExample ? (
        <div className="tg-start-post__buttons" aria-label="Пример кнопок стартового поста">
          <button type="button" disabled>
            Вперёд
          </button>
          <button type="button" disabled>
            Назад
          </button>
        </div>
      ) : null}
    </article>
  );
}

export default function TelegramChat(props) {
  const {
    selectedGameId,
    handleRequestFile,
    videoSrc,
    buttonsData,
    isLoading,
    localPreviewType,
    game,
  } = props;
  const messages = useSelector((state) => state.user?.messages);
  const messagesEndRef = useRef(null);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth", block: "end" });
  }, [messages, isLoading, videoSrc, buttonsData]);

  return (
    <div className="tgArea">
      <div className="tg-messages">
        {messages.map((el, index) => {
          if (el.type === "start-post") {
            return (
              <StartPostPreview
                key={`start-post-${index}`}
                preview={el.preview}
                label={el.label}
              />
            );
          }

          const meta = MESSAGE_META[el.type] ?? MESSAGE_META.help;
          const Icon = meta.icon;

          return (
            <article
              key={`${el.type}-${index}-${el.message?.slice(0, 24)}`}
              className={`tg-bubble tg-bubble--${el.type}`}
            >
              <div className="tg-bubble__head">
                <span className="tg-bubble__badge">
                  <Icon fontSize="inherit" />
                  {meta.label}
                </span>
              </div>
              <p className="tg-bubble__text">{el.message}</p>
            </article>
          );
        })}

        {isLoading && (
          <div className="tg-bubble tg-bubble--loading">
            <span className="tg-bubble__pulse" />
            Загрузка сцены…
          </div>
        )}

        {localPreviewType && game ? (
          <TelegramLocalPreview game={game} contentType={localPreviewType} />
        ) : null}

        <FileReceiver
          selectedGameId={selectedGameId}
          handleRequestFile={handleRequestFile}
          videoSrc={videoSrc}
          buttonsData={buttonsData}
        />

        <div ref={messagesEndRef} className="tg-messages__anchor" />
      </div>
    </div>
  );
}
